var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-4",attrs:{"elevation":"4"}},[_c('v-card-title',[_vm._v(" Profile Info ")])],1),_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"px-5"},[_c('v-card-text',[_c('generic-form',{attrs:{"fields-config":_vm.user.isDriver
                ? _vm.fieldsConfig
                : _vm.fieldsConfig.filter((header) => !header.isDriverSpecific),"data":_vm.user,"btns":{ show: ['submit'], submitLabel: 'Update' }},on:{"onSubmit":_vm.updateProfile}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }